import metaMap from './_metaMap.js';
import noop from './noop.js';

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

export default getData;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_getData.js
// module id = 336
// module chunks = 0